import store from '../store';
import Login from '../views/auth/Login.vue'
const ForgotPassword = () => import('../views/auth/ForgotPassword.vue')
const ResetPassword = () => import('../views/auth/ResetPassword.vue')
import {checkauth} from '../Helper'

export default [
    {
        path: '/login',
        name: 'login',
        component: Login,
        beforeEnter (to,from,next){
            checkauth().then( response =>{
                   // console.log(response)
                    if(response){
                        //console.log("login")
                        next('/home');
                    }else{
                        //console.log("next")
                        next();
                    };
                }

            )


            /*if(store.getters["profile/getAutenticate"]==1){
                next('/home');
            }else {
                next();
            }*/
        }
    },
    // recupero password: pagine pubbliche, raggiungibili senza sessione
    {
        path: '/forgot-password',
        name: 'forgot-password',
        component: ForgotPassword,
    },
    {
        path: '/reset-password',
        name: 'reset-password',
        component: ResetPassword,
    },


]
